import { studioSchema } from "schemas/studio.schemas/studio.schema";
import * as yup from "yup";

export const userStudioSchema = yup.object().shape({
  studio: studioSchema.required(),
  lastVisited: yup.date().required(),
});

export interface UserStudio extends yup.InferType<typeof userStudioSchema> {}
